/* zk-dates.js — تنظيف التواريخ وصف المواعيد */
(function(){
'use strict';
var R1K='يُغلق التسجيل';
var R1V='٣١ أغسطس';
var R2K='بعد الاشتراك مباشرة';
var R2V='التعليمات وبعض التمارين فورًا';
var NEW=R1V;
var LBL=R1K;
var ZW=String.fromCharCode(8203);
var DEAD=/(^|[^0-9٠-٩])(?:مساء\s*)?(?:15|18|25|27|28|١٥|١٨|٢٥|٢٧|٢٨)\s*أغسطس(?:\s*(?:2026|٢٠٢٦))?/g;
var ISDEAD=/(?:^|[^0-9٠-٩])(?:15|18|25|27|28|١٥|١٨|٢٥|٢٧|٢٨)\s*أغسطس/;
var KILL=/بداية\s+الجلسة/;
var LAUNCH=/إطلاق\s+النوايا/;
var OLDK=/ستظهر\s+تمارين\s+الجلسة|بداية\s+الجلسة|إطلاق\s+النوايا|انطلاق/;
var ANT=/انطلاقة?/g;

function fixDate(s){return String(s).replace(DEAD,'$1'+NEW)}

function shift(obj,pre,a,b){
  if(!obj)return;
  var rows=[],i,k1,k2,keys=[];
  for(i=1;i<=12;i++){
    k1=pre+i+a;k2=pre+i+b;
    if(!(k1 in obj)&&!(k2 in obj))continue;
    keys.push([k1,k2]);
    var nm=String(obj[k1]==null?'':obj[k1]);
    var dv=String(obj[k2]==null?'':obj[k2]);
    if(KILL.test(nm))continue;
    if(LAUNCH.test(nm))nm=LBL;
    if(ISDEAD.test(dv))dv=NEW;
    if(nm||dv)rows.push([nm,dv]);
  }
  if(!rows.length)return;
  for(i=0;i<keys.length;i++){
    var r=rows[i];
    obj[keys[i][0]]=r?r[0]:ZW;
    obj[keys[i][1]]=r?r[1]:ZW;
  }
}

function run(){
  var ZK=window.ZK||{};
  shift(ZK.bundle2,'s','n','d');
  shift(ZK.bundle,'s','n','d');
  shift(ZK.luck,'d','l','v');
  shift(ZK.luck2,'d','l','v');
  Object.keys(ZK).forEach(function(g){
    var o=ZK[g];if(!o||typeof o!=='object')return;
    Object.keys(o).forEach(function(k){
      if(typeof o[k]!=='string')return;
      if(KILL.test(o[k]))o[k]=o[k].replace(/\s*—?\s*بداية\s+الجلسة/g,'').trim();
      if(ISDEAD.test(o[k]))o[k]=fixDate(o[k]);
      if(ANT.test(o[k]))o[k]=o[k].replace(ANT,'').replace(/\s{2,}/g,' ').trim();
    });
  });
  var M=window.ZKM;
  if(M){
    if(M.date_label&&OLDK.test(M.date_label))M.date_label=R1K;
    if(M.date_value&&ISDEAD.test(M.date_value))M.date_value=R1V;
  }
}
run();

function mkRow(k,v){
  var d=document.createElement('div');d.className='dt';
  var s=document.createElement('span');s.className='k';s.textContent=k;
  var b=document.createElement('b');b.textContent=v;
  d.appendChild(s);d.appendChild(b);return d;
}

function dates(){
  var boxes=document.querySelectorAll('#zk .dates');
  for(var i=0;i<boxes.length;i++){
    var box=boxes[i];
    [].slice.call(box.querySelectorAll('.dt')).forEach(function(d){
      var k=d.querySelector('.k');
      if(k&&OLDK.test(k.textContent))d.remove();
    });
    var r1=null,r2=null;
    [].slice.call(box.querySelectorAll('.dt')).forEach(function(d){
      var k=d.querySelector('.k');if(!k)return;
      var t=k.textContent.trim();
      if(t===R1K){if(r1)d.remove();else r1=d;}
      else if(t===R2K){if(r2)d.remove();else r2=d;}
    });
    if(!r1)r1=mkRow(R1K,R1V);
    if(!r2)r2=mkRow(R2K,R2V);
    if(box.firstElementChild!==r1)box.insertBefore(r1,box.firstChild);
    if(r1.nextElementSibling!==r2)box.insertBefore(r2,r1.nextSibling);
  }
}

function sweep(){
  var root=document.getElementById('zk');if(!root)return;
  dates();
  var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n;
  while((n=w.nextNode())){
    var t=n.nodeValue;if(!t||!t.trim())continue;
    var o=t;
    t=t.replace(/\s*—?\s*بداية\s+الجلسة/g,'');
    t=fixDate(t);
    t=t.replace(ANT,'');
    if(t!==o)n.nodeValue=t;
  }
  var seen={},rows=[].slice.call(root.querySelectorAll('.dt'));
  rows.forEach(function(el){
    var raw=el.innerText||'';
    if(raw.indexOf(ZW)!==-1){el.remove();return}
    var k=raw.replace(/\s+/g,' ').trim();
    if(!k)return;
    if(seen[k]){el.remove();return}
    seen[k]=1;
  });
}
var tries=0;
(function go(){sweep();if(++tries<25)setTimeout(go,300)})();
})();
